"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Statamic = function Statamic(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.129 17.941c-.03-.213-.021-.713-.021-.713H2.82c-.662 0-.922-.267-.922-.93v-2.635c0-1.19-.278-1.481-.835-1.664v-.061c.557-.183.835-.486.835-1.676V7.638c0-.663.26-.87.92-.87h.285s.014-.457.045-.724c-.135-.018-.66-.03-.66-.03-1.334 0-1.709.646-1.709 1.979v2.391c0 .978-.569 1.109-.779 1.109v.95c.21 0 .765.132.765 1.094v2.406c0 1.334.374 1.964 1.709 1.964 0 0 .524.046.63.046l.025-.012zM2.318 12.59c.488 0 1.184.168 1.184 1.398v3.063c0 1.698.408 2.549 2.107 2.549h.765v-.908h-.39c-.84 0-1.154-.349-1.154-1.189v-3.359c0-1.515-.479-1.885-1.319-2.12v-.068c.84-.236 1.335-.623 1.335-2.138V6.466c0-.839.314-1.09 1.154-1.09h.389v-.974h-.75c-1.693 0-2.098.824-2.098 2.518v3.058c0 1.244-.689 1.425-1.185 1.425v1.198l-.038-.011zm11.487 3.898c.464-.131.854-.319 1.176-.565.32-.245.57-.548.75-.902.176-.355.266-.749.266-1.185 0-.379-.066-.705-.198-.974-.132-.271-.345-.506-.636-.712-.293-.206-.665-.391-1.118-.551-.452-.16-.999-.32-1.642-.479-.689-.175-1.166-.33-1.434-.465-.271-.14-.405-.362-.405-.672 0-.354.141-.614.423-.772.28-.166.627-.24 1.041-.24.445 0 .893.06 1.34.21.446.134.922.374 1.426.689l.945-1.425c-.551-.344-1.145-.615-1.779-.824-.63-.209-1.273-.3-1.904-.3-.51 0-.988.06-1.424.194-.435.136-.824.33-1.154.586-.332.254-.585.569-.766.929-.179.359-.27.78-.27 1.229 0 .344.06.629.181.885.119.254.299.465.554.659s.585.359 1.005.509c.42.15.914.301 1.499.436.778.18 1.319.345 1.648.51.33.149.495.39.495.705 0 .314-.135.568-.405.733s-.659.255-1.139.255c-1.064 0-2.174-.375-3.313-1.125l-.975 1.619c.271.181.57.346.915.495.345.15.704.271 1.079.375.375.105.765.181 1.17.24.404.06.779.074 1.139.074.569 0 1.08-.074 1.544-.209l-.034.068zm7.461-9.72c.66 0 .853.207.853.87v2.623c0 1.188.209 1.493 1.045 1.679v.052c-.836.185-1.045.476-1.045 1.663v2.643c0 .659-.192.929-.853.929h-.289s-.003.499-.031.71c.116 0 .575-.015.575-.015 1.335 0 1.643-.647 1.643-1.981v-2.398c0-.965.56-1.095.837-1.095v-.958c-.277 0-.837-.133-.837-1.109V7.993c0-1.334-.308-1.981-1.643-1.981 0 0-.47.015-.608.032.029.267.059.726.059.726h.285l.009-.002zM20.444 17.049v-3.063c0-1.229.697-1.397 1.185-1.397v-1.21c-.487 0-1.185-.168-1.185-1.413V6.918c0-1.697-.269-2.518-1.969-2.518h-.82v.975h.449c.84 0 1.086.25 1.086 1.091v3.349c0 1.514.419 1.9 1.259 2.136v.067c-.84.235-1.244.605-1.244 2.119v3.364c0 .843-.24 1.191-1.079 1.191h-.449v.908h.824c1.708 0 1.978-.853 1.978-2.552h-.035z"
  }));
};

Statamic.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes["default"].string,

  /**
   * The size of the Icon.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Statamic.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Statamic;
exports["default"] = _default;